<template>
  <el-form ref="form" :model="form">
    <gj-table
        ref="gjTable"
        :index="false"
        :data="form.childProductVOList"
        :columns="columns"
        :min-height="100"
        :show-overflow="false"
        :highlight-hover-row="false"
        :structure-config="{type: 'ParentChild', children: 'planSupplierInfoVOList', spanType: 'row', parentSpan: ['0-0', 12]}"
        :adapt-height="false"
    >
      <template v-slot:sku="{row}">
        <el-row :class="{'borderRight':row.childProductVOList&&row.childProductVOList.length>1}">
          <el-col :span="4" style="margin: 0 auto">
            <gj-image :src="form.purchaseType === 'single' ? form.smallImageUrl : form.childProductVOList[row.$gjParentIndex].smallImageUrl"></gj-image>
          </el-col>
          <el-col :span="19" :offset="1">
            <el-row>
              <el-col :span="6.2" class="text-label">{{ form.purchaseType === 'single' ? "SKU:" : "子件SKU:" }}</el-col>
              <el-col :span="17.8" class="text-val">
                {{ form.purchaseType === 'single' ? row.sku : form.childProductVOList[row.$gjParentIndex].sku }}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6.2" class="text-label">产品名称:</el-col>
              <el-col :span="17" class="text-val" v-if="form.purchaseType === 'single'">
                <gj-text max-width="95%">{{ form.productName }}</gj-text>
              </el-col>
              <el-col :span="17" class="text-val" v-if="form.purchaseType === 'split'">
                <gj-text max-width="95%">{{ form.childProductVOList[row.$gjParentIndex].productName }}</gj-text>
              </el-col>
            </el-row>
            <el-row v-if="form.purchaseType === 'split'">
              <el-col :span="12" class="text-label">
                需求量:
                <span class="text-val">{{ row.childPlanQuantity }}</span>
              </el-col>
              <el-col :span="12" class="text-label">
                已分单量:
                <span :class="{'text-val':true,'error-tips':form.childProductVOList[row.$gjParentIndex].errorTips}">
                  {{form.childProductVOList[row.$gjParentIndex].sumSplitQuantity}}</span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </template>
      <template v-slot:code="{row}">
        <el-form-item
            :prop="`childProductVOList.${row.$gjParentIndex}.planSupplierInfoVOList.${row.$gjChildIndex}.supplierCode`"
            :rules="[{ required: true, message: '请选择供应商', trigger: ['change','blur'] }]"
            class="gj-table-item">
          <gj-select
              v-model="form.childProductVOList[row.$gjParentIndex].planSupplierInfoVOList[row.$gjChildIndex].supplierCode"
              :options="form.childProductVOList[row.$gjParentIndex].supplierInfoVOList" placeholder="请选择供应商"
              style="width: 140px"
              @change="changeSuppler($event, form.childProductVOList[row.$gjParentIndex].planSupplierInfoVOList, form.childProductVOList[row.$gjParentIndex].supplierInfoVOList, row)">
          </gj-select>
        </el-form-item>
      </template>
      <template v-slot:includeTaxPrice="{row}">
        <el-form-item
            :prop="`childProductVOList.${row.$gjParentIndex}.planSupplierInfoVOList.${row.$gjChildIndex}.includeTaxPrice`"
            :rules="[{ required: true, message: '请输入含税单价', trigger: ['change','blur'] }]"
            class="gj-table-item">
          <gj-input
              v-model="form.childProductVOList[row.$gjParentIndex].planSupplierInfoVOList[row.$gjChildIndex].includeTaxPrice"
              :clearable="false"
              maxlength="11"
              :ref="`childProductVOList.${row.$gjParentIndex}.planSupplierInfoVOList.${row.$gjChildIndex}.includeTaxPrice`"
              @change="changeIncludeTaxPrice($event,row)"
              width="120px" v-number.price>
            <template #prepend>
              {{row.currencySymbol}}
            </template>
          </gj-input>
        </el-form-item>
      </template>
      <template v-slot:splitOrderQuantity="{row}">
        <el-form-item
            :prop="`childProductVOList.${row.$gjParentIndex}.planSupplierInfoVOList.${row.$gjChildIndex}.splitOrderQuantity`"
            :rules="[{ required: true, message: '请输入分单量', trigger: ['change','blur'] },{ validator:checkPlanQuantity,trigger: ['change','blur']}]"
            class="gj-table-item">
          <gj-input
              v-model="form.childProductVOList[row.$gjParentIndex].planSupplierInfoVOList[row.$gjChildIndex].splitOrderQuantity"
              :ref="`childProductVOList.${row.$gjParentIndex}.planSupplierInfoVOList.${row.$gjChildIndex}.splitOrderQuantity`"
              width="100px"
              :clearable="false"
              v-number.positive></gj-input>
        </el-form-item>
      </template>
      <template v-slot:op="{row}">
        <gj-button type="text" @click="pushItem(row.$gjParentIndex)">
          <i class="el-icon-circle-plus-outline" style="font-size: 20px;color: #333333;"></i>
        </gj-button>
        <gj-button type="text" @click="deleteItem(row.$gjParentIndex, row.$gjChildIndex)"
                   v-show="form.childProductVOList[row.$gjParentIndex].planSupplierInfoVOList.length > 1">
          <i class="el-icon-remove-outline" style="font-size: 20px;color: #333333;"></i>
        </gj-button>
      </template>
    </gj-table>
  </el-form>
</template>

<script>
import {formDeleteItemMixin, formRuleMixin, responseMixin, selectionMixin} from "@/minxins";
import {isMeaningful} from "@/utils/common";

export default {
  name: "op-purchase-plan-order-table",
  mixins: [formRuleMixin, responseMixin, formDeleteItemMixin, selectionMixin],
  components: {},
  props: {
    form: {
      required: true
    },
    mountTo: {
      required: true
    },
    openValidate:{
      required: false
    }
  },
  data() {
    return {
      planDeliveryDate: '',
      deliveryWarehouse: '',
      planDataVisible: false,
      warehouseVisible: false,
      columns: [
        {id: 'sku', header: ' ', field: 'slot:sku', minWidth: '280px', align: 'left'},
        {id: 'code', header: '供应商', field: 'slot:code', minWidth: '160px', align: 'left'},
        {id: 'moq', header: '最小起订量', field: 'moq', width: '80px', align: 'left'},
        {id: 'purchaseDeliveryDays', header: '采购交期（天）', field: 'purchaseDeliveryDays', minWidth: '105px', align: 'left'},
        {id: 'currency', header: '币种', field: 'currency', minWidth: '60px', align: 'left'},
        {id: 'excludeTaxPrice', header: '不含税单价', field: 'excludeTaxPrice',prefix: 'currencySymbol', minWidth: '80px', align: 'right'},
        {id: 'includeTaxPrice', header: '含税单价', field: 'slot:includeTaxPrice', minWidth: '130px', align: 'left'},
        {id: 'invoiceTaxRate', header: '票面税率(%)', field: 'invoiceTaxRate', minWidth: '100px', align: 'left'},
        {id: 'actualTaxRate', header: '实际税率(%)', field: 'actualTaxRate', minWidth: '100px', align: 'left'},
        {id: 'settlementWay', header: '结算方式', field: 'option:settlementWay', options: [{id: 'monthly', text: '月结'}, {id: 'cash', text: '现结'}], minWidth: '70px', align: 'left'},
        {id: 'splitOrderQuantity ', header: '分单量', field: 'slot:splitOrderQuantity', minWidth: '120px', align: 'left'},
        {id: 'op', header: ' ', field: 'slot:op', minWidth: '80px', align: 'left', fixed: 'right'},
      ],
    }
  },
  methods: {
    parseRule(rule) {
      let arr = rule.field.split('.');
      let result = [];
      arr.forEach(item => {
        if (!isNaN(Number(item))) {  // 非数字
          result.push(Number(item));
        }
      })
      return result;
    },
    checkPlanQuantity(rule, value, callback) {
      if(!this.openValidate){
         callback();
         return;
      }
      if (this.form.purchaseType === 'single') {  // 单采
        // 获取 具体的 行数据
        if(this.form.childProductVOList[this.parseRule(rule)[0]].planSupplierInfoVOList.length > 1){  // 多行数据
          if (this.form.planQuantity !== this.form.sumSingleQuantity) {  // 需求量 和 分单量 合计相比
            if(this.parseRule(rule)[1] === 0){
              callback(new Error('分单合计需要等于需求量'))
            }else{
              callback(new Error(' '));
            }
          }else{
            callback();
            this.$refs.form.clearValidate();
          }
        }else{   // 如果只有一行
          if (this.form.planQuantity !== this.form.sumSingleQuantity) {
            callback(new Error('分单量需要等于需求量'))
          }else{
            callback()
          }
        }
      }else{
        if(this.form.childProductVOList[this.parseRule(rule)[0]].planSupplierInfoVOList.length > 1) {  // 多行数据
          if (this.form.childProductVOList[this.parseRule(rule)[0]].childPlanQuantity !== this.form.childProductVOList[this.parseRule(rule)[0]].sumSplitQuantity) {
            if(this.parseRule(rule)[1] === 0){
              callback(new Error('分单合计需要等于需求量'))
            }else{
              callback(new Error(' '))
            }
          }else{
            callback();
            for(let i = 0; i < this.form.childProductVOList[this.parseRule(rule)[0]].planSupplierInfoVOList.length; i++ ){
              this.$refs.form.clearValidate(`childProductVOList.${this.parseRule(rule)[0]}.planSupplierInfoVOList.${i}.splitOrderQuantity`);
            }
          }
        }else{   // 如果只有一行
          if (this.form.childProductVOList[this.parseRule(rule)[0]].childPlanQuantity !== this.form.childProductVOList[this.parseRule(rule)[0]].sumSplitQuantity) {
            callback(new Error('分单量需要等于需求量'))
          }else{
            callback()
          }
        }
      }
    },
    changeSuppler(val, planSupperList, supperList, row) {
      if (val) {
        if (planSupperList.filter(v => v.supplierCode === val).length > 1) {
          this.$gjMessage.error("不能选择相同的供应商");
          this.resetSuppler(row, planSupperList);
        } else {
          let supplier = Object.assign(row, ...supperList.filter(sup => sup.supplierCode === val));
          planSupperList.splice(row.$gjChildIndex, 1, supplier)
        }
      } else {
        this.resetSuppler(row, planSupperList);
      }
      this.form.childProductVOList[row.$gjParentIndex].supplierInfoVOList.forEach(item=>{
        let findSupplier = planSupperList.find(plan => plan.supplierCode === item.supplierCode)
        item.disabled = !!findSupplier;
        if(item.supplierCode === val) item.disabled = true;
      })
    },
    changeIncludeTaxPrice(val, row) {
      row.excludeTaxPrice = val ? (val * (100 - row.actualTaxRate) / 100).toFixed(2) : null;
      this.form.childProductVOList[row.$gjParentIndex].planSupplierInfoVOList[row.$gjChildIndex].excludeTaxPrice = row.excludeTaxPrice;
    },
    deleteItem(parentIndex, index) {
      if(this.form.childProductVOList[parentIndex].supplierInfoVOList &&  this.form.childProductVOList[parentIndex].supplierInfoVOList.length > 0){
        this.form.childProductVOList[parentIndex].supplierInfoVOList.forEach(item=>{
          if(item.supplierCode === this.form.childProductVOList[parentIndex].planSupplierInfoVOList[index].supplierCode) item.disabled = false;
        })
      }
      this.form.childProductVOList[parentIndex].planSupplierInfoVOList.splice(index, 1);
      this.form.childProductVOList = [...this.form.childProductVOList];
      if(this.openValidate){
        this.$nextTick(()=>{
          this.$refs.form.validate();
        })
      }
    },
    pushItem(index) {
      this.form.childProductVOList[index].planSupplierInfoVOList.push({
        'splitOrderQuantity': null,
        'includeTaxPrice': null,
        'excludeTaxPrice': null,
        'supplierCode': null
      });
      this.form.childProductVOList = [...this.form.childProductVOList];
    },
    updateItems(data) {
      if (isMeaningful(data)) {
        data.forEach(newItem => {
          const find = this.form.childProductVOList.find(oldItem => newItem['id'] === oldItem['id']);
          if (find) {
            Object.assign(find, this.mapToItem(newItem));
          } else {
            this.form.childProductVOList.push(this.mapToItem(newItem));
          }
        });
      }
    },
    mapToItem(item) {
      return {
        ...item,
        urgent: item.urgent || null,
        planDeliveryDate: item.planDeliveryDate || null,
        planQuantity: item.planQuantity || null,
        deliveryWarehouse: item.deliveryWarehouse || null,
        deliveryWarehouseName: item.deliveryWarehouseName || null,
        memo: item.memo || null
      }
    },
    formValidate() {
      if (this._.isEmpty(this.form.childProductVOList)) {
        this.$gjMessage.error('没有可生成采购单的数据');
        return false;
      }
      return this.$gjFormValidate();
    },
    resetSuppler(suppler, row) {
      row[suppler.$gjChildIndex].includeTaxPrice = null
      row[suppler.$gjChildIndex].splitOrderQuantity = null;
      suppler.actualTaxRate = null;
      suppler.currency = null;
      suppler.excludeTaxPrice = null;
      suppler.invoiceTaxRate = null;
      suppler.moq = null;
      suppler.purchaseDeliveryDays = null;
      suppler.settlementWay = null;
      suppler.supplierCode = null;
      suppler.supplierName = null;
      suppler.text = null;
    }
  }
}
</script>

<style lang="scss" scoped>
.text-label {
  font-size: 12px;
  color: #999999;
  line-height: 20px;
  font-weight: 400;
  text-align: left;
}

.text-val {
  text-align: left;
  color: #333333;
  line-height: 20px;
  font-weight: 400;
}
/deep/ .el-input__inner{
  padding-left: 15px;
}
/deep/ .vxe-table--border-line{
  border: none;
}
.borderRight{
  border-right: 1px solid #e8eaec;
}
/deep/ .vxe-table--body{
  .vxe-body--row{
    .vxe-body--column{
      padding: 10px 0!important;
    }
  }
}
.error-tips{
  color: red;
}
</style>
